<div id="ranking" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Accreditation / Ranking System</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College, Sirsa is accredited by the <strong>National Assessment and Accreditation Council
        (NAAC)</strong>. The college also actively participates in the <strong>National Institutional Ranking Framework
        (NIRF)</strong> to benchmark itself against institutions across India.
    </p>

    <hr class="divider">

    <div class="info-card-grid mt-section">
      <div class="info-card">
        <p class="info-card-title">NAAC Accreditation</p>
        <p class="info-card-text">The college has been assessed and accredited by NAAC, the premier quality assurance
          body for higher education in India.</p>
        <a href="/assets/pdf/iqac/NAAC-metrices.pdf" target="_blank" class="download-btn mt-2">
          <i class="fa fa-download"></i> View NAAC Report
        </a>
      </div>
      <div class="info-card">
        <p class="info-card-title">NIRF Ranking</p>
        <p class="info-card-text">The college participates in NIRF which ranks institutions on parameters such as
          Teaching, Learning & Resources, Research, Graduation Outcomes, Outreach and Perception.</p>
        <a href="/assets/pdf/NIRF-DCS-Shah-Satnam-Ji-Girls-College-Sirsa.pdf" target="_blank" class="download-btn mt-2">
          <i class="fa fa-download"></i> View NIRF Report
        </a>
      </div>
      <div class="info-card">
        <p class="info-card-title">AISHE Data</p>
        <p class="info-card-text">Annual filing with the All India Survey on Higher Education (AISHE) portal as mandated
          by the Ministry of Education.</p>
        <a href="/assets/pdf/iqac/AISHE.pdf" target="_blank" class="download-btn mt-2">
          <i class="fa fa-download"></i> View AISHE Data
        </a>
      </div>
    </div>

  </div>
</div>